import {useMutation} from '@apollo/react-hooks';

import type {
    CancelBooking as CancelBookingMutation,
    CancelBookingVariables as CancelBookingMutationVariables,
    GetMeeting as GetMeetingQuery,
} from 'nutshell-graphql-types';

import CANCEL_BOOKING from '../mutations/cancel-booking.graphql';
import GET_MEETING from '../queries/get-meeting.graphql';

export function useCancelBooking(): (input: {
    bookingId: string;
    meetingId: string;
    optionalMessage?: string | null | undefined;
}) => Promise<any> {
    const [cancelBooking] = useMutation<CancelBookingMutation, CancelBookingMutationVariables>(
        CANCEL_BOOKING
    );

    return (input: {
        bookingId: string;
        meetingId: string;
        optionalMessage?: string | null | undefined;
    }) => {
        return cancelBooking({
            variables: {
                input: {
                    id: input.bookingId,
                    optionalMessage: input.optionalMessage,
                },
            },

            update: (proxy, mutationResults) => {
                const cacheResult: GetMeetingQuery | null | undefined = proxy.readQuery({
                    query: GET_MEETING,
                    variables: {id: input.meetingId},
                });
                const cancelledBooking =
                    mutationResults &&
                    mutationResults.data &&
                    mutationResults.data.bookingCancel &&
                    mutationResults.data.bookingCancel.booking;

                if (!cancelledBooking) return;

                if (cacheResult) {
                    const newBookings = cacheResult.meeting.bookings.map((booking) =>
                        booking.id === cancelledBooking.id ? cancelledBooking : booking
                    );

                    proxy.writeQuery({
                        query: GET_MEETING,
                        variables: {input},
                        data: {
                            meeting: {
                                ...cacheResult.meeting,
                                bookings: newBookings,
                            },
                        },
                    });
                }
            },
        });
    };
}
